export default __webpack_public_path__ + "img/bMXhWwPr.f3d55249.svg";